import React, { useEffect, useState } from "react";
import api from "@/lib/api";

/** useCMS - fetch a CMS content block, fall back to seed default. */
export function useCMSContent(key, fallback) {
  const [data, setData] = useState(fallback || null);
  useEffect(() => {
    let alive = true;
    api.get(`/cms/content/${encodeURIComponent(key)}`)
       .then((r) => { if (alive && r.data && Object.keys(r.data).length) setData(r.data); })
       .catch(() => {});
    return () => { alive = false; };
  }, [key]);
  return data;
}

/** useCMSList - fetch a CMS list (testimonials / case_studies / etc.) */
export function useCMSList(kind) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    let alive = true;
    api.get(`/cms/list/${kind}`)
       .then((r) => { if (alive) setItems(r.data || []); })
       .catch(() => {});
    return () => { alive = false; };
  }, [kind]);
  return items;
}
